import loadable from "~/utils/loadable";
import Loading from "~/common/components/indicators/Loading";

export default loadable(() => import("./index"), {
  fallback: <Loading />
});
